import { FC, useMemo } from 'react';
import cx from 'classnames';

interface SkeletonTextProps {
  width?: string;
  textSizeClass: string;
}
const SkeletonText: FC<SkeletonTextProps> = ({ width, textSizeClass }) => {
  const randomWidth = useMemo(() => {
    if (width) return null;
    const widthOptions = ['10%', '15%', '20%', '25%', '30%', '35%', '40%', '45%'];
    const randomIndex = Math.floor(Math.random() * widthOptions.length);
    return widthOptions[randomIndex];
  }, [width]);

  return (
    <div
      className={cx(
        'relative my-auto',
        {
          'max-w-[30%]': !randomWidth,
        },
        width,
      )}
      style={randomWidth ? { width: randomWidth } : undefined}
      data-test-id="skeleton-text"
    >
      <span className={cx('invisible', textSizeClass)}>Ag</span>
      <div
        className="absolute animate-[skeleton-loading_1.5s_ease-in-out_infinite_alternate] rounded bg-gray-300"
        style={{
          left: 0,
          right: 0,
          top: '0.1em',
          bottom: '0.1em',
          willChange: 'background-color',
          transform: 'translateZ(0)',
        }}
      />
    </div>
  );
};

export default SkeletonText;
